<script setup lang="ts">
import TargetDetailPage from '../features/links/TargetDetailPage.vue';

const props = defineProps<{
  targetKey: string;
}>();
</script>

<template>
  <TargetDetailPage :target-key="props.targetKey" />
</template>
